/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorJwVideoArticle from 'base/components/labrador/JwVideo/Article';

export const DynamicLabradorJwVideoArticle: typeof LabradorJwVideoArticle = (props) => {
    return <ErrorBoundary><LabradorJwVideoArticle {...props} /></ErrorBoundary>;
}
export type DynamicLabradorJwVideoArticleProps = PropsFromComponent<typeof LabradorJwVideoArticle>;
